import { decrypt, encrypt } from '@/helpers/encryption';
import { STORAGE, useLocalStorageStore } from '@/store';

export interface IUserData {
  email?: string | null;
  avatarId?: number | null;
}

export const getUserData = (): IUserData | null => {
  const data = useLocalStorageStore
    .getState()
    .get<IUserData | null>(STORAGE.USER_DATA);

  if (data == null) {
    return null;
  }

  let decryptedEmail = null;
  if (data.email) {
    try {
      decryptedEmail = decrypt(data.email);
    } catch {
      decryptedEmail = null;
    }
  }

  return {
    ...data,
    email: decryptedEmail,
  };
};

export const saveUserData = (partial: Partial<IUserData>) => {
  const userData =
    useLocalStorageStore.getState().get<IUserData | null>(STORAGE.USER_DATA) ??
    {};

  useLocalStorageStore.getState().replace(STORAGE.USER_DATA, {
    email: partial.email ? encrypt(partial.email) : userData.email,
    avatarId:
      partial.avatarId !== undefined ? partial.avatarId : userData.avatarId,
  });
};

export const obscureEmail = (email?: string) => {
  if (email == null) return;

  try {
    const [name, domain] = email.split('@');
    return name
      .substr(0, 3)
      .concat(Array(name.length - 3).join('*'))
      .concat('@')
      .concat(domain);
  } catch {
    return;
  }
};
